import React, { FC, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { CardActionArea } from "@material-ui/core";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import SnackBarAlert from "../../components/Alerts/AlertComponent";
import * as Validations from "../../helpers/validations";

import { addToCart, resetMessage } from '../../flux/actions/shoppingCart-actions';
import { listProductDetails } from '../../flux/actions/product-actions';
import soldOut from '../../assets/sold_out.png';
import { NotFoundSearch } from "../../views/NotFoundSearch";

const useStyles = makeStyles({
  root: {
    width: 345,
    left: 16,
    top: 97,
    height: "auto",
  },
  qtyContainer: {
    "& > *": {
      margin: "8px",
      width: "25ch",
    },
  },
  media: {
    height: 300,
    paddingTop: "56.25%",
    width: "auto",
    backgroundsize: "auto",
  },
  soldOut: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
  }
});

const ProductCard: FC = () => {
  const [count, setCount] = useState(1);
  const [isProductInCart, setIsProductInCart] = useState(false);

  const classes = useStyles();
  const history = useHistory();

  const dispatch = useDispatch();
  const cart = useSelector((state: any) => state.cart);
  const { isProductAdded, cartItems } = cart;
  const productDetails = useSelector((state: any) => state.productReducer);
  const { product = {} } = productDetails;

  const buyProductHandler = (id: string) => {
    history.push(`/cart/${id}?qty=${count}`);
  }

  const addToCartHandler = (id: string) => {
    let productInCart = cartItems.some((item:any) => item.id === id);
    if (!productInCart) {
      dispatch(addToCart(id, count));
    } else {
      setIsProductInCart(true);
    }
  }

  const amountHandler = (e : any) => {
    if (Validations.formatInteger(e.target.value)) {
      setCount(e.target.value);
    } else {
      setCount(1);
    }

    if (e.target.value >= product.amount) {
      setCount(product.amount);
    }
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setIsProductInCart(false);
  };

  return (
    <Grid
      alignItems="center"
      direction="row"
      justify="center"
      container
      item
      xs={12}
      sm={12}
    >
      {isProductAdded && <SnackBarAlert severity='success' message='Se ha agregado un producto al carrito' open={isProductAdded}/>}
      {isProductInCart && <SnackBarAlert severity='info' message='Este producto ya fue agregado, modifica la cantidad en tu carrito!' open={isProductInCart} onClose={handleClose}/>}
      {product.isDelete ? <NotFoundSearch/> :
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image={product.image}
              title={product.full_name}
            />
            {((product.amount === 0 || !product.status) || !product.categoryRef.isActive) && 
              <img className={classes.soldOut} src={soldOut} alt="Sold Out"/>}
          </CardActionArea>
          <CardContent>
            <Typography variant="h5" component="h2">
              {product.full_name}
            </Typography>
            <div style={{ width: "100%" }}>
              <Box alignItems="flex-start" display="flex">
                <Box flexGrow={1}>
                  <Typography color="textSecondary">Precio</Typography>
                  <Typography display="block" color="secondary">
                    ${product.cost ? product.cost.toFixed(2) : ''}
                  </Typography>
                  <br />
                </Box>
                {(product.amount > 0 && product.status && product.categoryRef.isActive) && 
                  <Box className={classes.qtyContainer}>
                    <button
                      onClick={() => setCount(count <= 0 ? 1 : count - 1)}
                      className="buttonStyleAdd "
                    >
                      -
                    </button>
                    <input
                      className="quantityStyle"
                      type="text"
                      value={count}
                      onChange={amountHandler}
                    />
                    <button
                      onClick={() => setCount(count >= product.amount ? product.amount : count + 1)}
                      className="buttonStyleAdd"
                    >
                      +
                    </button>
                  </Box>
                }
              </Box>
            </div>
            <Typography variant="body2" component="p">
              {product.description}
              </Typography><br />
                {
                  product.amount === count &&
                    <Typography variant="subtitle2" component="p" align="center">
                      La compra esta limitada a {product.amount} unidades del producto
                    </Typography>
                }
          </CardContent>
          {(product.amount > 0 && product.status && product.categoryRef.isActive) &&
            <CardActions>
              <Button 
                size="small"
                onClick={() => buyProductHandler(product._id)}
              >
                Comprar
              </Button>
              <Button 
                color="secondary" 
                size="small"
                onClick={() => addToCartHandler(product._id)}
              >
                Añadir
              </Button>
            </CardActions>
          }
        </Card>
      }
    </Grid>
  );
};

export default ProductCard;
